"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = exports.RescueType = exports.StatusApprovalTransaction = exports.StatusTransaction = void 0;
var StatusTransaction;
(function (StatusTransaction) {
    StatusTransaction["REQUESTED"] = "REQUESTED";
    StatusTransaction["ON_HOLD"] = "ON_HOLD";
    StatusTransaction["UNCONFIRMED"] = "UNCONFIRMED";
    StatusTransaction["REJECTED"] = "REJECTED";
    StatusTransaction["CONFIRMED"] = "CONFIRMED";
    StatusTransaction["COMPLETED"] = "COMPLETED";
})(StatusTransaction || (exports.StatusTransaction = StatusTransaction = {}));
var StatusApprovalTransaction;
(function (StatusApprovalTransaction) {
    StatusApprovalTransaction["APPROVED"] = "APPROVED";
    StatusApprovalTransaction["DENIED"] = "DENIED";
})(StatusApprovalTransaction || (exports.StatusApprovalTransaction = StatusApprovalTransaction = {}));
var RescueType;
(function (RescueType) {
    RescueType["PARTIAL"] = "PARTIAL";
    RescueType["TOTAL"] = "TOTAL";
})(RescueType || (exports.RescueType = RescueType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["BUY"] = "BUY";
    TransactionType["SELL"] = "SELL";
    TransactionType["FUNDSWITCH"] = "FUNDSWITCH";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
//# sourceMappingURL=index.js.map